import React, { Component } from 'react';

class Header extends Component {
  render() {

    if(this.props.data){
      var profilepic= "images/"+this.props.data.image;
      var name = this.props.data.name;
      //var occupation= this.props.data.occupation;
      var descriptionList = this.props.data.descriptionList.map(function(description){
         return <h3 key={description}>{description}</h3>
       })
      //var city= this.props.data.address.city;
      //var resumeDownload = this.props.data.resumedownload;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url} alt={network.name} title={network.name} target="_blank"><i className={network.className}></i></a></li>
      })
    }

    return (
      <header id="home">

      <nav id="nav-wrap">

         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#education">Education</a></li>
            <li><a className="smoothscroll" href="#work">Work</a></li>
            <li><a className="smoothscroll" href="#skill">Skills</a></li>
         </ul>

      </nav>

      <div className="row banner">
         <div className="banner-text">
            <img className="profile-pic" src={profilepic} alt="Sertaç Güralp" />
            <h1 className="responsive-headline">I'm {name}.</h1>
            {descriptionList}
            <hr />
            <ul className="social">
               {networks}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#education"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js